import { setIsPending, updateAccessToken } from '@gef-ui/redux-common/actions/appContext';
import { getRefreshToken, isPending } from '@gef-ui/redux-common/selectors/appContext';
import sleep from "@gef-ui/utils/sleep";
import invariant from 'invariant';
import o from "ramda/es/o";
import prop from "ramda/es/prop";
import { postApplicationJson } from '../../../facade/index';
import { withLogout } from '../../access/facade';
import { authHeaderFactory } from '../../utils';
export default ((body, beforeLogout)=>async (dispatch, getState)=>{
        const state = getState();
        const refreshToken = getRefreshToken(state);
        invariant(refreshToken, 'Unable to obtain access token without refresh token.');
        if (isPending(state)) {
            while(isPending(getState())){
                await sleep(500);
            }
            return Promise.resolve();
        }
        dispatch(setIsPending(true));
        return dispatch(withLogout(postApplicationJson)({
            endpoint: ({ urls })=>`${urls.token}/access`,
            additionalHeaders: authHeaderFactory(getRefreshToken),
            body,
            actions: {
                onSuccess: [
                    o(updateAccessToken, prop('body')),
                    setIsPending(false)
                ],
                onError: setIsPending(false)
            },
            beforeLogout
        }));
    });
